<app-privacy-banner></app-privacy-banner>

@if (!hideNav) {
  <nav class="hl-nav">
    <div class="hl-logo">Han<span>dle</span></div>
    <div class="hl-nav-sub">Student Career Guidance</div>
  </nav>
}

<router-outlet></router-outlet>
<app-ada-menu [alignRight]="isCounselorView"></app-ada-menu>
